export default __webpack_public_path__ + "locales/pt-BR/VersionHistory.json?hash=5f3d01b2b9da2bb7cd093fe25466fa6e";